import React, { Component } from 'react';
import Modal from './Modal'
import Page from './Page'
import { Button, Checkmark } from '../generic';
import { withRouter } from 'react-router-dom';

class Form extends Component {
  constructor(props) {
    super(props)
    this.state = {
      event: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  handleSubmit(e) {
    this.props.onSubmit()
    e.preventDefault()
  }

  handleCancel(e) {
    e.preventDefault()
    this.props.history.push(this.props.previousPath)
  }

  render() {
    const { onSubmit, error, valid } = this.props
    const Wrapper = this.props.isModal ? Modal : Page
    return (
      <Wrapper {...this.props}>
        <form onSubmit={this.handleSubmit}>
          {error && <div>Error: {error}</div>}
          {React.cloneElement(this.props.children, {
            onSubmit
          })}
          <Button type="button" cancel="true" style={{ marginRight: '10px', marginBottom: '8px' }} onClick={this.handleCancel}>&lt; Go back</Button>
          <Button type="submit" disabled={!valid}><Checkmark light={valid ? "true" : null} /> Complete</Button>
        </form>
      </Wrapper>
    )
  }
}

export default withRouter(Form)

